export type MultiSelectMessages = {
  multiSelectTooltipWarning1: string;
  multiSelectTooltipWarning2: string;
};

export const MULTI_SELECT_MESSAGES: MultiSelectMessages = {
  multiSelectTooltipWarning1: "Você só pode selecionar",
  multiSelectTooltipWarning2: "opções.",
};
